import React, { useState } from 'react';
import { Card, Form, Button } from 'react-bootstrap';
import rcmlogo from '../../assets/images/rcmlogo.png';
import axios from 'axios';
import { Link, useSearchParams , useNavigate} from 'react-router-dom';
import { useAppDispatch } from '../../core/redux/hooks';
import { showToaster } from '../../core/redux/toastSlice';

const SetPassword = () => {

    const [searchParams] = useSearchParams();

    const apiBases = process.env.REACT_APP_API_URL;

    const [password, setPassword] = useState("");
    const [confpass, setConfpass] = useState("");
    const [responseData, setResponseData] = useState(false);
    const [passwordType, setPasswordType] = useState<string>("password");
    const [confpasswordType, setConfpasswordType] = useState<string>("password");
    const [type, setType] = useState(searchParams.get('type'));
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const gotologin = () => {
        navigate('/', {state : {message : "Your password Updated Successfully"}})
    }

    const togglePassword =(e:any)=>{
        if(passwordType==="password")
        {
         setPasswordType("text")
         return;
        }
        setPasswordType("password")
    }

    const toggleConfirmPassword =(e:any)=>{
        
            if(confpasswordType==="password")
            {
            setConfpasswordType("text")
            return;
            }
            setConfpasswordType("password");
    }

    const handleSubmit = (e:any) => {
        e.preventDefault();
        if (!password) {
            dispatch(showToaster(
                {
                    dialogBgColor: 'bg-danger',
                    dialogMsg: "Password is required",
                    showDialog: true,
                    timer: '5000'
                }
            ));
            return false;
        } else if (!confpass) {
            dispatch(showToaster(
                {
                    dialogBgColor: 'bg-danger',
                    dialogMsg: "Confirm password is required",
                    showDialog: true,
                    timer: '5000'
                }
            ));
        } else {
            if (!password.trim().match(/^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&!]).*$/)) {
                dispatch(showToaster(
                    {
                        dialogBgColor: 'bg-danger',
                        dialogMsg: "Password is invalid",
                        showDialog: true,
                        timer: '5000'
                    }
                ));
                return false;
            } else {
                if (password.trim() === confpass.trim()) {
                    const data = {
                        userId: searchParams.get('id'),
                        token: searchParams.get('token'),
                        password: password.trim()
                    }
                    axios.post(apiBases + '/admin/auth/update_password', data)
                        .then((res) => {
                            if (res.data.status === "Success") {
                                setResponseData(true);
                                gotologin();
                            }
                        })
                        .catch((err) => {
                            dispatch(showToaster(
                                {
                                    dialogBgColor: 'bg-danger',
                                    dialogMsg: err.response.data.message ? err.response.data.message : 'Something went wrong!',
                                    showDialog: true,
                                    timer: '5000'
                                }
                            ));
                        })
                } else {
                    dispatch(showToaster(
                        {
                            dialogBgColor: 'bg-danger',
                            dialogMsg: "Please check Password and confirm password should be same...",
                            showDialog: true,
                            timer: '5000'
                        }
                    ));
                }
            }
        }

    }

    return (

        <>

            <div className="setcard">
                <Card className="" >
                    <Card.Img src={rcmlogo} alt="Card image" className="rcmlogo" />

                    <Card.Body>
                        <div className='text-center'>
                            {
                                responseData ? <small className='text-success' >Password updated Succesfully. Please <span><Link to="/sign-in"><b>Click Here</b></Link></span> to Login </small> : ""
                            }
                        </div>

                        
                        <Form onSubmit={handleSubmit}>
                            <div className="m-3">
                            <small className="text-info">Note : Passwords should contain a minimum of 8 characters, contain at least one uppercase letter, and contain at least one special character </small>
                                <div className='mb-2'>
                                    <label><b>Enter Your Password Here</b> </label>
                                </div>
                                <div className='input-group'>
                                    <input type={passwordType} name="password" onChange={(e) => { setPassword(e.target.value.trim());}} className="form-control" />
                                        <button className="input-group-text btn btn-outline-primary" type="button" onClick={(e)=>togglePassword(e)}>
                                            { passwordType==="password"? <i className="bi bi-eye-slash"></i> :<i className="bi bi-eye"></i> }
                                        </button>
                                </div>
                            </div>
                            <div className="m-3">
                                <div className='mb-2'>
                                    <label><b>Confirm Your Password Here</b> </label>
                                </div>
                                <div className='input-group'>
                                    <input type={confpasswordType} name="confirmpassword" onChange={(e) => { setConfpass(e.target.value.trim());}} className="form-control" />
                                    <button className="input-group-text btn btn-outline-primary" type="button" onClick={(e)=>toggleConfirmPassword(e)}>
                                        { confpasswordType==="password"? <i className="bi bi-eye-slash"></i> :<i className="bi bi-eye"></i> }
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="text-center" >
                                    {(type != null && type !== "") ? <Button style={{ backgroundColor: '#0187c4' }} type="submit" className="m-3">Create Your Password</Button> : <Button style={{ backgroundColor: '#0187c4' }} type="submit" className="m-3">Reset Your Password</Button>}
                                </div>
                            </div>
                        </Form>

                    </Card.Body>
                </Card>
            </div>

        </>

    )


}

export default SetPassword;